export default __webpack_public_path__ + "static/codeediting-106cff864c0bece45ba4b81ce4dc6073.mp4";